import { QueryClient } from '@tanstack/react-query';

import { useGetMagazinesQuery } from '@/hooks/magazine/mobile/magazine.gql.impl';
import { parseMagazineHomeNewest } from '@/parsers/Communication/magazine';
import * as Types from '@/types/bff/gql-schema';

const useGetMagazines = () => {
  const { data: magazines, isLoading: magazinesIsLoading } =
    useGetMagazinesQuery(
      {
        magazineCursorPageRequestInput: {
          size: 5,
        },
      },
      {
        select: (data) =>
          parseMagazineHomeNewest(data.magazineCursorPage.elements),
      },
    );
  return {
    magazines: magazines ?? [],
    magazinesIsLoading,
  };
};

export default useGetMagazines;

useGetMagazines.prefetchQuery = async (
  queryClient: QueryClient,
  variables: Types.GetMagazinesQueryVariables,
) => {
  await queryClient.prefetchQuery(
    useGetMagazinesQuery.getKey(variables),
    useGetMagazinesQuery.fetcher(variables),
  );
};

useGetMagazines.fetchQuery = async (
  queryClient: QueryClient,
  variables: Types.GetMagazinesQueryVariables,
) => {
  const response = await queryClient.fetchQuery(
    useGetMagazinesQuery.getKey(variables),
    useGetMagazinesQuery.fetcher(variables),
  );

  return response;
};
